import React, { useState } from 'react';
import './index.css';
import { AppProvider } from './context/AppContext';
import Dashboard from './pages/Dashboard';
import Ledger from './pages/Ledger';
import AddTransaction from './pages/AddTransaction';

const PAGES = {
  dashboard: { label: 'Dashboard', icon: '◈', component: Dashboard },
  ledger: { label: 'Stock Ledger', icon: '≡', component: Ledger },
  add: { label: 'Add Transaction', icon: '+', component: AddTransaction }
};

export default function App() {
  const [page, setPage] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const CurrentPage = PAGES[page].component;

  return (
    <AppProvider>
      <div className="app-shell">
        {/* Mobile menu button */}
        <button className="mobile-menu-btn" onClick={() => setSidebarOpen(o => !o)}>
          ☰
        </button>

        {/* Sidebar */}
        <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
          <div className="sidebar-logo">
            <h1>Stock<span>Ledger</span></h1>
            <div style={{ fontSize: '0.72rem', color: 'var(--text-dim)', marginTop: 4 }}>
              Portfolio Tracker
            </div>
          </div>
          <nav className="sidebar-nav">
            {Object.entries(PAGES).map(([key, { label, icon }]) => (
              <div
                key={key}
                className={`nav-item ${page === key ? 'active' : ''}`}
                onClick={() => { setPage(key); setSidebarOpen(false); }}
              >
                <span className="icon">{icon}</span>
                {label}
              </div>
            ))}
          </nav>
          <div style={{ padding: '16px 20px', fontSize: '0.7rem', color: 'var(--text-dim)', borderTop: '1px solid var(--border)' }}>
            All amounts in ₹ INR
          </div>
        </aside>

        {/* Main */}
        <main className="main-content">
          <CurrentPage navigate={setPage} />
        </main>
      </div>
    </AppProvider>
  );
}
